import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import extend from 'lodash/extend';
import chunk from 'lodash/chunk';
import { withRouter } from 'react-router';
// import { canUseDOM } from 'exenv';
import Ad from '../../../components/ad/ad';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import Slug from '../../../components/slug/slug';
import MCPSection from '../../../components/mcp_section/mcp_section';
import FeatureFeed from '../../../components/feature_feed/feature_feed';
import matchMediaDesktop from '../../../../utils/client_util';

function mapPostsToFeaturedStoriesObj(featuredFeed) {
  const stories = get(featuredFeed, 'data.posts') || [];

  return {
    top: stories.slice(1),
    featured: stories.slice(0, 1)
  };
}

class MostCreativePeople extends Component {
  // eslint-disable-next-line react/prefer-stateless-function
  componentDidMount() {
    this.isDesktop = matchMediaDesktop('64em');
  }

  render() {
    const {
      mostCreativePeoplePage,
      mostCreativePeople,
      mostCreativePeopleFeaturedFeed,
      mostCreativePeopleScrollingModule,
      status
    } = this.props;

    if (mostCreativePeoplePage.error || status === 404) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (mostCreativePeoplePage.isLoading) {
      return (
        <section className="most-creative-people-page">
          <article className="most-creative-people-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const adData = get(mostCreativePeoplePage, 'ads');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    const year = get(this.props, 'match.params.year');
    const pgTitle = `The Most Creative People In Business ${year}`;
    const pgDesc =
      'These inspiring leaders are shaping the future of business in creative ways. Scroll to see the Top 100.';
    const sectionTitle = `Meet The 100 Most Creative People in Business ${year}`;
    const mcpSections = mostCreativePeople.map((people, index) => ({
      id: `section-${index + 1}`,
      people
    }));

    const encodedText = encodeURIComponent(
      `The Most Creative People In Business ${year} #FCMostCreative`
    );
    const uri = encodeURIComponent(
      `https://www.fastcompany.com/most-creative-people/${year}`
    );
    return (
      <section className="most-creative-people-page">
        <Ad {...combinedAdModel} name="oop" slug="false" oop="true" />
        <section className="page-title">
          <Slug slugName={pgTitle} className="category-page" />
          <h3 className="page-description">{pgDesc}</h3>
        </section>

        <FeatureFeed
          featuredFeed={mapPostsToFeaturedStoriesObj(
            mostCreativePeopleFeaturedFeed
          )}
          scrollingModule={mostCreativePeopleScrollingModule}
          currentSite="fastcompany"
          page={'most-creative-people'}
          combinedAdModel={combinedAdModel}
          social={{
            enableSticky: false,
            modifier: 'feature-feed',
            text: encodedText,
            uri
          }}
        />

        <section className="mcp-list">
          <Slug slugName={sectionTitle} className="mcp-list" />

          {mcpSections.map(
            (col, idx) =>
              (idx % 2 === 0 || idx === 0) &&
              <MCPSection
                key={col.id}
                data={col.people.concat(mcpSections[idx + 1].people || [])}
                combinedAdModel={combinedAdModel}
                index={String(idx)}
              />
          )}
        </section>
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  const mcpData = chunk(get(state, 'mostCreativePeople.data.rows'), 10);
  return {
    config: state.config || {},
    status: state.status.code,
    mostCreativePeoplePage: get(state, 'mostCreativePeoplePage') || {
      error: true
    },
    mostCreativePeople: mcpData || [],
    mostCreativePeopleFeaturedFeed:
      get(state, 'mostCreativePeopleFeaturedFeed') || {},
    mostCreativePeopleScrollingModule:
      get(state, 'mostCreativePeopleScrollingModule.data') || {}
  };
}

MostCreativePeople.propTypes = {
  status: PropTypes.number.isRequired,
  mostCreativePeoplePage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  mostCreativePeople: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({})))
    .isRequired,
  mostCreativePeopleFeaturedFeed: PropTypes.shape({}).isRequired,
  mostCreativePeopleScrollingModule: PropTypes.shape({}).isRequired
};

export default withRouter(connect(mapStateToProps)(MostCreativePeople));



// WEBPACK FOOTER //
// ./src/views/containers/pages/most_creative_people_page/most_creative_people_page.js